module.exports = "<li *ngIf=\"allowed\">\r\n   \r\n    <a [class]=\"className\" [routerLink]=\"link\">\r\n        <span class=\"dash\"></span>\r\n        <ng-content></ng-content>\r\n        <span class=\"arrow\"></span>\r\n\r\n    </a>\r\n</li>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/PageLink/page-link.component.html
// module id = ../../../../../app/shared/components/PageLink/page-link.component.html
// module chunks = main